import {
    VkOrdAgencyActStatus,
    VkOrdAgencyContractStatus,
} from '@synapex/prisma/client'

export type DocumentStatus = VkOrdAgencyContractStatus | VkOrdAgencyActStatus

export type StatusContent = {
    value: DocumentStatus
    title: string
    style: {
        color?: string
        backgroundColor: string
    }
    checkStyle?: { color: string }
    allowSelect: boolean
    allowRenderInSelector: boolean
}

export type ContractAgencyStatusContent = StatusContent & {
    value: VkOrdAgencyContractStatus
}

export type ActAgencyStatusContent = StatusContent & {
    value: VkOrdAgencyActStatus
}

export const CONTRACT_AGENCY_STATUS_CONTENT: Record<
    VkOrdAgencyContractStatus,
    ContractAgencyStatusContent
> = {
    new: {
        value: 'new',
        title: 'Новый',
        style: {
            color: '#94A6AF',
            backgroundColor: '#E0E7EE',
        },
        checkStyle: { color: '#056FFF' },
        allowSelect: true,
        allowRenderInSelector: true,
    },
    in_work: {
        value: 'in_work',
        title: 'В работе',
        style: { backgroundColor: '#FFB641' },
        allowSelect: true,
        allowRenderInSelector: true,
    },
    done: {
        value: 'done',
        title: 'Завершен',
        style: { backgroundColor: '#52D05D' },
        allowSelect: true,
        allowRenderInSelector: true,
    },
}

export const ACT_AGENCY_STATUS_CONTENT: Record<
    VkOrdAgencyActStatus,
    ActAgencyStatusContent
> = {
    not_formed: {
        value: 'not_formed',
        title: 'Загрузить акт в ОРД',
        style: {
            backgroundColor: '#FFB641',
        },
        allowSelect: true,
        allowRenderInSelector: true,
    },
    waiting_to_load: {
        value: 'waiting_to_load',
        title: 'Ожидает загрузки в ОРД',
        style: { backgroundColor: '#35B2FF' },
        allowSelect: false,
        allowRenderInSelector: false,
    },
    formed: {
        value: 'formed',
        title: 'Загружен в ОРД',
        style: { backgroundColor: '#52D05D' },
        allowSelect: true,
        allowRenderInSelector: true,
    },
}

export const ALL_STATUS_CONTENT: Record<DocumentStatus, StatusContent> = {
    ...CONTRACT_AGENCY_STATUS_CONTENT,
    ...ACT_AGENCY_STATUS_CONTENT,
}

export type DocumentType = 'contract' | 'act'

export const getStatusContentByType = (
    type: DocumentType
): Record<string, StatusContent> => {
    switch (type) {
        case 'contract':
            return CONTRACT_AGENCY_STATUS_CONTENT as Record<
                string,
                StatusContent
            >
        case 'act':
            return ACT_AGENCY_STATUS_CONTENT as Record<string, StatusContent>
        default:
            return ALL_STATUS_CONTENT
    }
}
